"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _draftJs = require("draft-js");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _makeTypingTriggerRegex = _interopRequireDefault(require("draft-plugins/utils/makeTypingTriggerRegex"));

var _createGetVisibleSelectionRectAtTrigger = _interopRequireDefault(require("draft-plugins/utils/createGetVisibleSelectionRectAtTrigger"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _OverlayResultsContainer = _interopRequireDefault(require("./OverlayResultsContainer"));

var _getOverlayAnchorPosition = _interopRequireDefault(require("../../utils/getOverlayAnchorPosition"));

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      data = _ref.data,
      dataProp = _ref.dataProp,
      trigger = _ref.trigger,
      _ref$maximumSearch = _ref.maximumSearch,
      maximumSearch = _ref$maximumSearch === void 0 ? 10 : _ref$maximumSearch,
      portalId = _ref.portalId,
      ResultsComponent = _ref.ResultsComponent,
      _ref$overlayPositioni = _ref.overlayPositioning,
      overlayPositioning = _ref$overlayPositioni === void 0 ? {
    placement: 'bottom right',
    targetAttachment: 'bottom right'
  } : _ref$overlayPositioni,
      _ref$transformData = _ref.transformData,
      transformData = _ref$transformData === void 0 ? _identity.default : _ref$transformData;

  var TYPING_TRIGGER_REGEX = (0, _makeTypingTriggerRegex.default)({
    trigger: trigger,
    maximumSearch: maximumSearch
  });
  var getVisibleSelectionRectAtTrigger = (0, _createGetVisibleSelectionRectAtTrigger.default)({
    trigger: trigger,
    maximumSearch: maximumSearch
  });
  var ResultsContainer = (0, _OverlayResultsContainer.default)(ResultsComponent);
  var memoizedTransformData = (0, _memoize.default)(transformData);
  return _react.default.createClass({
    propTypes: {
      editorState: _react.PropTypes.object.isRequired,
      onChange: _react.PropTypes.func.isRequired,
      addKeyCommandListener: _react.PropTypes.func.isRequired,
      removeKeyCommandListener: _react.PropTypes.func.isRequired,
      onOpen: _react.PropTypes.func,
      onClose: _react.PropTypes.func,
      onSelect: _react.PropTypes.func
    },
    getInitialState: function getInitialState() {
      return {
        // Keeps the overlay onscreen when editor is out of focus
        forceOverlayFocus: false,
        // Force closes the overlay if a user doesn't want to use the shortcut
        forceCloseSelection: false
      };
    },
    componentWillMount: function componentWillMount() {
      // Save coordinates for the dropdown so that we can use this if there is
      // no current window selection (eg. when we want to forceOverlay but editor isn't focused)
      this.savedCoordinates = {};
    },
    getCurrentSearch: function getCurrentSearch() {
      var editorState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.editorState;
      var selection = editorState.getSelection();
      var _this$state = this.state,
          forceCloseSelection = _this$state.forceCloseSelection,
          forceOverlayFocus = _this$state.forceOverlayFocus;

      if (!selection.getHasFocus() && !forceOverlayFocus) {
        return null;
      }

      var contentState = editorState.getCurrentContent();
      var block = contentState.getBlockForKey(selection.getStartKey());
      var blockText = block && block.getText();
      var offset = selection.getStartOffset();

      if (!selection.isCollapsed() || blockText === undefined) {
        return null;
      }

      var matchArray = blockText.slice(0, offset).match(TYPING_TRIGGER_REGEX);

      if (matchArray === null) {
        return null;
      }

      var beforeCursorText = matchArray[0].slice(trigger.length);
      var pastCursorMatch = blockText.slice(offset).match(/^\w+/);
      var pastCursorText = pastCursorMatch !== null ? pastCursorMatch[0] : '';

      if (forceCloseSelection && forceCloseSelection === selection) {
        return null;
      }

      return {
        search: beforeCursorText + pastCursorText,
        offset: offset - beforeCursorText.length - trigger.length,
        length: trigger.length + beforeCursorText.length + pastCursorText.length
      };
    },
    handleToggleForcedOverlayFocus: function handleToggleForcedOverlayFocus(isFocused) {
      // eslint-disable-next-line react/no-is-mounted
      if (this.isMounted()) {
        this.setState({
          forceOverlayFocus: isFocused
        });
      }
    },
    cancel: function cancel(_ref2) {
      var offset = _ref2.offset,
          length = _ref2.length;
      var _this$props = this.props,
          editorState = _this$props.editorState,
          onChange = _this$props.onChange;
      var blockKey = editorState.getSelection().getStartKey();

      var targetRange = _draftJs.SelectionState.createEmpty(blockKey).merge({
        anchorOffset: offset + length,
        focusOffset: offset + length,
        isBackward: false,
        hasFocus: true
      });

      var contentState = _draftJs.Modifier.insertText(editorState.getCurrentContent(), targetRange, '  ');

      onChange(_draftJs.EditorState.push(editorState, contentState, 'insert-characters'));
    },
    forceClose: function forceClose() {
      this.setState({
        forceCloseSelection: this.props.editorState.getSelection()
      });
    },
    getResults: function getResults(search) {
      var regex = new RegExp(search.trim().replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
      var correctData = this.props[dataProp] || data || [];
      var transformedData = memoizedTransformData(correctData);
      return transformedData.filter(function (_ref3) {
        var value = _ref3.value,
            searchText = _ref3.searchText,
            text = _ref3.text;
        var toSearch = searchText || text;
        return toSearch.match(regex) !== null || value.toString().match(regex) !== null;
      });
    },
    saveCoordinates: function saveCoordinates(boundingRect) {
      this.savedCoordinates = boundingRect;
    },
    renderDropdown: function renderDropdown(currentSearch) {
      if (currentSearch === null) {
        return _react.default.createElement("div", null);
      }

      var _this$props2 = this.props,
          addKeyCommandListener = _this$props2.addKeyCommandListener,
          removeKeyCommandListener = _this$props2.removeKeyCommandListener,
          onSelect = _this$props2.onSelect;
      var results = this.getResults(currentSearch.search);
      return _react.default.createElement("div", {
        ref: "dropdown",
        className: "overlay-dropdown"
      }, _react.default.createElement(ResultsContainer, (0, _extends2.default)({}, currentSearch, {
        portalId: portalId,
        results: results,
        onSelect: onSelect,
        onCancel: this.cancel,
        forceClose: this.forceClose,
        toggleForcedOverlayFocus: this.handleToggleForcedOverlayFocus,
        addKeyCommandListener: addKeyCommandListener,
        removeKeyCommandListener: removeKeyCommandListener
      })));
    },
    renderTriggerAnchor: function renderTriggerAnchor(shouldBeOpen) {
      if (!shouldBeOpen) {
        return null;
      }

      var placement = overlayPositioning.placement;
      var coordinates = this.state.forceOverlayFocus ? this.savedCoordinates : getVisibleSelectionRectAtTrigger(this.saveCoordinates) || this.savedCoordinates;

      if (coordinates === null) {
        return null;
      }

      var _getOverlayAnchorPosi = (0, _getOverlayAnchorPosition.default)(placement, coordinates),
          top = _getOverlayAnchorPosi.top,
          left = _getOverlayAnchorPosi.left;

      return _react.default.createElement("div", {
        className: "trigger-anchor",
        style: {
          position: 'fixed',
          visibility: 'hidden',
          top: top,
          left: left
        }
      });
    },
    render: function render() {
      var _this$props3 = this.props,
          onOpen = _this$props3.onOpen,
          onClose = _this$props3.onClose;
      var currentSearch = this.getCurrentSearch();
      var shouldBeOpen = currentSearch !== null;
      var placement = overlayPositioning.placement,
          targetAttachment = overlayPositioning.targetAttachment;
      return _react.default.createElement(_UIPopover.default, {
        open: shouldBeOpen,
        content: this.renderDropdown(currentSearch),
        placement: placement,
        targetAttachment: targetAttachment,
        onOpenComplete: onOpen,
        onCloseComplete: onClose
      }, this.renderTriggerAnchor(shouldBeOpen));
    }
  });
};

exports.default = _default;
module.exports = exports.default;